// API Configuration
const API_CONFIG = {
  // Use environment variable if available, otherwise detect based on hostname
  BASE_URL: process.env.REACT_APP_API_URL || 
    (window.location.hostname === 'localhost' 
      ? 'http://localhost:8000' 
      : 'https://pharmadashv2-backend.onrender.com'),
  // Visualization settings
  CHARTS: {
    COUNTRY_GROWTH: {
      TOP_N: 12,
      EXCLUDE_COUNTRIES: ['Others', 'RoW', 'ROW'],
      MIN_BASE_M: 5, // show warning if start revenue < $5M
      WARNING_ABS_CAGR_PCT: 50 // show warning if |CAGR| > 50%
    }
  }
};

export default API_CONFIG;
